import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Inject, Injectable } from "@angular/core";
import { Location } from "@angular/common";
import { Observable, of } from "rxjs";
import { concatMap } from "rxjs/operators";

import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from "@azure/msal-angular";
import { AccountInfo } from "@azure/msal-browser";

import { BaseGuard } from "@app/guards/base.guard";
import { AlertService } from '@app/modules/alert';
import { getCurrentUserFromStorage} from "@app/utils/storage-utils";

import { GlobalService } from '@app-services/global.services';
import { GraphService } from '@app-services/graph.service';
import { GlobalConstants } from '@app-utils/global-constants';

type AccountWithGroupClaims = AccountInfo & {
    idTokenClaims?: {
        groups?: string[],
        _claim_names?: {
            groups?: string | string[]
        },
        _claim_sources?: {
            src1?: {
                endpoint: string | string[]
            }
        }
    }
}

@Injectable()
export class SponsoredGuard extends BaseGuard {

    constructor(
        @Inject(MSAL_GUARD_CONFIG) protected override msalGuardConfig: MsalGuardConfiguration,
        protected override msalBroadcastService: MsalBroadcastService,
        protected override authService: MsalService,
        protected override location: Location,
        protected override router: Router,
        private alertService: AlertService,
        private graphService: GraphService,
        private globalService: GlobalService,
    ) {
        super(msalGuardConfig, msalBroadcastService, authService, location, router,);
    }

    override activateHelper(state?: RouterStateSnapshot, route?: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        const result = super.activateHelper(state, route);
        //console.log('activateHelper - PM Guard');
    
        return result.pipe(
           
            concatMap(() => {

                let activeAccount = this.authService.instance.getActiveAccount() as AccountWithGroupClaims;

                if (!activeAccount && this.authService.instance.getAllAccounts().length > 0) {
                    activeAccount = this.authService.instance.getAllAccounts()[0] as AccountWithGroupClaims;
                }
                let isSponsor = this.globalService.isSponsorUser;
                

                if (!isSponsor) {
                    this.alertService.error('You do not have access to this function. (4).');
                }


                if (activeAccount && getCurrentUserFromStorage() == GlobalConstants.noLoggedInUser) {
                    this.getCurrentUser();
                }

                return of(isSponsor);
            })
        );
    }
    async getCurrentUser() {
        const currentUser = await  this.graphService.getCurrentUser();
        //console.log(currentUser);
    }

}